(function () {

    // Open external links in new tab
    const links = document.links; 
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
      if (links[i].hostname !== window.location.hostname) { 
        links[i].target = '_blank'; 
        links[i].rel = 'noreferrer noopener'; 
      } 
    }
  
	// Function to get all the next siblings of an element
	const nextSiblings = (currentElement) => {
		let next_siblings = [];
		let sibling = currentElement.nextElementSibling;

		while (sibling) {
			next_siblings.push(sibling);
			sibling = sibling.nextElementSibling;
		}

		return next_siblings;
	}

	const footer = () => {
		 const caculateNewsletterMargin = () => {
			//debugger;
			const footerNewsletter = document.querySelector(".footer--newsletter__form--center");

		// Only proceed if the newsletter form exists
		if (footerNewsletter) {
			let footerParent = footerNewsletter.parentNode;
			let footerStyles = window.getComputedStyle(footerParent);

			// Calculate the total height of next siblings
			let marginTop = nextSiblings(footerNewsletter).reduce((totalHeight, sibling) => {
				const siblingHeight = sibling.offsetHeight || 0; // Handle hidden elements
				return totalHeight + siblingHeight;
			}, 0) - parseInt(footerStyles.getPropertyValue('padding-top'), 10);
			
			let enoughSpace = (window.outerHeight - marginTop * 2 - footerNewsletter.offsetHeight) > 0;

			marginTop = marginTop > 0 && enoughSpace ? marginTop : 0;

			// Apply the calculated margin to the newsletter
			footerNewsletter.style.marginTop = `${marginTop}px`;
		 }
		}

		caculateNewsletterMargin();
		window.addEventListener("resize", () => setTimeout(() =>caculateNewsletterMargin(), 500));
	}

	// Reapply the footer logic when the section is reloaded
	document.addEventListener('shopify:section:load', footer);
	footer();
})();